import moment from "moment";

const DATE_FORMAT = "MMM Do, YYYY";

const formatDateRateDate = (date: Date, locale: string) =>
  moment(date).locale(locale).format(DATE_FORMAT);

/**
 * Formats a row's dates for the table: one date ("Dec 10th, 2026") or a range
 * ("Dec 10th, 2026 - Dec 12th, 2026").
 */
const formatDateRateRange = (
  { endDate, startDate }: { endDate: Date; startDate: Date },
  locale: string,
) => {
  const start = formatDateRateDate(startDate, locale);
  const end = formatDateRateDate(endDate, locale);

  return start === end ? start : `${start} - ${end}`;
};

export { formatDateRateRange };
